import React from 'react';

import Button from '../../../../../components/Button';

const CategoryController = (props) => {
  const { isShow, isInexhibitDisable, isExhibitDisable, onInexhibit, onExhibit } = props;

  return (
    isShow && (
      <div className="category-exhibit-button-list-wrap">
        <Button isRadius color="primary" text="제외" disabled={isInexhibitDisable} onClick={onInexhibit} />
        <Button isRadius color="primary" text="추가" disabled={isExhibitDisable} onClick={onExhibit} />
      </div>
    )
  );
};

export default CategoryController;
